export const popoverPriorityStack = {
  CountrySwitchPopup: 0,
};
